// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-134Ll";
var _4 = "header-2l-8n";
var _5 = "group-11v-b";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "header", _5 as "group" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "header": _4, "group": _5 }
